<template>
  <div id="app">
    <router-view />
    <!-- <div onclick="qimoChatClick()" class="qimoClick">在线客服</div> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" >
    @import "assets/scss/base.scss";
    #app {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    .qimoClick{
    position:fixed;
    right:0;
    top:50%;
    margin-top:-37px;
    z-index: 9999;
    width: 64px;
    padding:42px 0 12px;
    height:20px;
    line-height: 20px;
    text-align: center;
    background:  #006EFB url("./assets/icon-zaixiankefu.png") no-repeat center 12px;
    background-size: 26px 25px;
    border-radius: 2px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #FFFFFF;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue